module.exports={render:function (){with(this) {
  return _h('div', {
    attrs: {
      "id": "app"
    }
  }, [_m(0), " ", _m(1), " ", _l((items), function(item) {
    return _h('div', [_h('lazy-item', {
      attrs: {
        "item-data": item
      }
    }), " ", _m(2, true)])
  }), " ", _h('load-more', {
    attrs: {
      "is-loading": isLoading
    },
    nativeOn: {
      "click": function($event) {
        toggleLoad($event)
      }
    }
  })])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "head"
  }, [_h('h2', ["Vue lazy scroll loading"])])
}},function (){with(this) {
  return _h('div', {
    staticClass: "descp"
  }, [_h('p', ["基于", _h('b', ["Vue2.0"]), "实现，图片随滚动", _h('b', ["延迟"]), "加载，先请求", _h('b', ["缩略图"]), "，缩略图加载后带模糊效果。滚动到底部后可", _h('b', ["异步加载"]), "更多内容，实现无限加载。"])])
}},function (){with(this) {
  return _h('i', {
    staticClass: "divide"
  })
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 11
 ** module chunks = 1
 **/